import { IGigTypeExperienceReducer } from 'models/Experience'
import { Action } from 'redux'
import { isType } from 'ts-action'
import { GetGigTypeExperiences, GigTypeExperiencesFetching } from './actions'

const initialState: IGigTypeExperienceReducer = {
  meta: {
    code: 0,
    message: '',
  },
  isFetching: false,
  data: [],
}

export const gigTypeExperiencesReducer = (
  state = initialState,
  action: Action
): IGigTypeExperienceReducer => {
  if (isType(action, GetGigTypeExperiences)) {
    const { payload } = action
    return {
      ...state,
      meta: payload.meta,
      data: payload.data,
    }
  }
  if (isType(action, GigTypeExperiencesFetching)) {
    const { payload } = action
    return {
      ...state,
      isFetching: payload,
    }
  }
  return state
}
